/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CountryEnum = {
    AFG: 'AFG',
    ALB: 'ALB',
    DZA: 'DZA',
    ASM: 'ASM',
    AND: 'AND',
    AGO: 'AGO',
    AIA: 'AIA',
    ATA: 'ATA',
    ATG: 'ATG',
    ARG: 'ARG',
    ARM: 'ARM',
    ABW: 'ABW',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BHS: 'BHS',
    BHR: 'BHR',
    BGD: 'BGD',
    BRB: 'BRB',
    BLR: 'BLR',
    BEL: 'BEL',
    BLZ: 'BLZ',
    BEN: 'BEN',
    BMU: 'BMU',
    BTN: 'BTN',
    BOL: 'BOL',
    BES: 'BES',
    BIH: 'BIH',
    BWA: 'BWA',
    BVT: 'BVT',
    BRA: 'BRA',
    IOT: 'IOT',
    BRN: 'BRN',
    BGR: 'BGR',
    BFA: 'BFA',
    BDI: 'BDI',
    CPV: 'CPV',
    KHM: 'KHM',
    CMR: 'CMR',
    CAN: 'CAN',
    CYM: 'CYM',
    CAF: 'CAF',
    TCD: 'TCD',
    CHL: 'CHL',
    CHN: 'CHN',
    CXR: 'CXR',
    CCK: 'CCK',
    COL: 'COL',
    COM: 'COM',
    COG: 'COG',
    COD: 'COD',
    COK: 'COK',
    CRI: 'CRI',
    HRV: 'HRV',
    CUB: 'CUB',
    CUW: 'CUW',
    CYP: 'CYP',
    CZE: 'CZE',
    CIV: 'CIV',
    DNK: 'DNK',
    DJI: 'DJI',
    DMA: 'DMA',
    DOM: 'DOM',
    ECU: 'ECU',
    EGY: 'EGY',
    SLV: 'SLV',
    GNQ: 'GNQ',
    ERI: 'ERI',
    EST: 'EST',
    SWZ: 'SWZ',
    ETH: 'ETH',
    FLK: 'FLK',
    FRO: 'FRO',
    FJI: 'FJI',
    FIN: 'FIN',
    FRA: 'FRA',
    GUF: 'GUF',
    PYF: 'PYF',
    ATF: 'ATF',
    GAB: 'GAB',
    GMB: 'GMB',
    GEO: 'GEO',
    DEU: 'DEU',
    GHA: 'GHA',
    GIB: 'GIB',
    GRC: 'GRC',
    GRL: 'GRL',
    GRD: 'GRD',
    GLP: 'GLP',
    GUM: 'GUM',
    GTM: 'GTM',
    GGY: 'GGY',
    GIN: 'GIN',
    GNB: 'GNB',
    GUY: 'GUY',
    HTI: 'HTI',
    HMD: 'HMD',
    VAT: 'VAT',
    HND: 'HND',
    HKG: 'HKG',
    HUN: 'HUN',
    ISL: 'ISL',
    IND: 'IND',
    IDN: 'IDN',
    IRN: 'IRN',
    IRQ: 'IRQ',
    IRL: 'IRL',
    IMN: 'IMN',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JPN: 'JPN',
    JEY: 'JEY',
    JOR: 'JOR',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KIR: 'KIR',
    PRK: 'PRK',
    KOR: 'KOR',
    XKX: 'XKX',
    KWT: 'KWT',
    KGZ: 'KGZ',
    LAO: 'LAO',
    LVA: 'LVA',
    LBN: 'LBN',
    LSO: 'LSO',
    LBR: 'LBR',
    LBY: 'LBY',
    LIE: 'LIE',
    LTU: 'LTU',
    LUX: 'LUX',
    MAC: 'MAC',
    MDG: 'MDG',
    MWI: 'MWI',
    MYS: 'MYS',
    MDV: 'MDV',
    MLI: 'MLI',
    MLT: 'MLT',
    MHL: 'MHL',
    MTQ: 'MTQ',
    MRT: 'MRT',
    MUS: 'MUS',
    MYT: 'MYT',
    MEX: 'MEX',
    FSM: 'FSM',
    MDA: 'MDA',
    MCO: 'MCO',
    MNG: 'MNG',
    MNE: 'MNE',
    MSR: 'MSR',
    MAR: 'MAR',
    MOZ: 'MOZ',
    MMR: 'MMR',
    NAM: 'NAM',
    NRU: 'NRU',
    NPL: 'NPL',
    NLD: 'NLD',
    NCL: 'NCL',
    NZL: 'NZL',
    NIC: 'NIC',
    NER: 'NER',
    NGA: 'NGA',
    NIU: 'NIU',
    NFK: 'NFK',
    MKD: 'MKD',
    MNP: 'MNP',
    NOR: 'NOR',
    OMN: 'OMN',
    PAK: 'PAK',
    PLW: 'PLW',
    PSE: 'PSE',
    PAN: 'PAN',
    PNG: 'PNG',
    PRY: 'PRY',
    PER: 'PER',
    PHL: 'PHL',
    PCN: 'PCN',
    POL: 'POL',
    PRT: 'PRT',
    PRI: 'PRI',
    QAT: 'QAT',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    REU: 'REU',
    BLM: 'BLM',
    SHN: 'SHN',
    KNA: 'KNA',
    LCA: 'LCA',
    MAF: 'MAF',
    SPM: 'SPM',
    VCT: 'VCT',
    WSM: 'WSM',
    SMR: 'SMR',
    STP: 'STP',
    SAU: 'SAU',
    SEN: 'SEN',
    SRB: 'SRB',
    SYC: 'SYC',
    SLE: 'SLE',
    SGP: 'SGP',
    SXM: 'SXM',
    SVK: 'SVK',
    SVN: 'SVN',
    SLB: 'SLB',
    SOM: 'SOM',
    ZAF: 'ZAF',
    SGS: 'SGS',
    SSD: 'SSD',
    ESP: 'ESP',
    LKA: 'LKA',
    SDN: 'SDN',
    SUR: 'SUR',
    SJM: 'SJM',
    SWE: 'SWE',
    CHE: 'CHE',
    SYR: 'SYR',
    TWN: 'TWN',
    TJK: 'TJK',
    TZA: 'TZA',
    THA: 'THA',
    TLS: 'TLS',
    TGO: 'TGO',
    TKL: 'TKL',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TKM: 'TKM',
    TCA: 'TCA',
    TUV: 'TUV',
    TUR: 'TUR',
    UGA: 'UGA',
    UKR: 'UKR',
    ARE: 'ARE',
    GBR: 'GBR',
    UMI: 'UMI',
    USA: 'USA',
    URY: 'URY',
    UZB: 'UZB',
    VUT: 'VUT',
    VEN: 'VEN',
    VNM: 'VNM',
    VGB: 'VGB',
    VIR: 'VIR',
    WLF: 'WLF',
    ESH: 'ESH',
    YEM: 'YEM',
    ZMB: 'ZMB',
    ZWE: 'ZWE',
    ALA: 'ALA'
} as const;
export type CountryEnum = typeof CountryEnum[keyof typeof CountryEnum];


export function instanceOfCountryEnum(value: any): boolean {
    for (const key in CountryEnum) {
        if (Object.prototype.hasOwnProperty.call(CountryEnum, key)) {
            if (CountryEnum[key as keyof typeof CountryEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CountryEnumFromJSON(json: any): CountryEnum {
    return CountryEnumFromJSONTyped(json, false);
}

export function CountryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryEnum {
    return json as CountryEnum;
}

export function CountryEnumToJSON(value?: CountryEnum | null): any {
    return value as any;
}

